import { AlertTitle as MuiAlertTitle, styled } from '@mui/material';

/**
 * A styled component used by `AlertTitle` only when it is nested within a `WsdAlert` component.
 */
export const WsdAlertTitleRoot = styled(MuiAlertTitle, {
  name: 'WsdAlertTitle',
  slot: 'Root',
})(() => ({
  fontSize: 18,
  fontWeight: 'normal',
  lineHeight: 1.2,
  letterSpacing: 'normal',
  margin: '0 0 17px',
}));

export default WsdAlertTitleRoot;
